
import { mapState } from 'vuex'
import { prettyLicenseName } from '~/utils/helpers'

export default {
  filters: { prettyLicenseName },
  props: {
    cartItem: { type: Object }
  },
  computed: mapState({ licenses: state => state.checkout.licenses }),
  data () {
    return {
      licenseId: null,
      disabled: false
    }
  },
  created () {
    this.licenseId = this.cartItem.license ? this.cartItem.license.id : null
  },
  methods: {
    async updateLicense () {
      this.$emit('changing', true)
      this.disabled = true
      await this.$store.dispatch(
        'checkout/updateCartItemLicense',
        { item: this.cartItem, licenseId: this.licenseId, $backend: this.$backend, $matomo: this.$matomo }
      )
      this.disabled = false
      this.$emit('changing', false)
    }
  }
}
